import Vue from "vue";
import VueRouter from "vue-router";
import Cookies from "js-cookie";
import Dashboard from "@/views/dashboard/Dashboard.vue";
import Layout from "@/views/dashboard/Layout.vue";
import Review from "@/views/dashboard/Review.vue";
import Quote from "@/views/dashboard/Quote.vue";
import Package from "@/views/dashboard/Package.vue";
import TourAdd from "@/views/dashboard/TourAdd.vue";
import TourEdit from "@/views/dashboard/TourEdit.vue";
import TourClone from "@/views/dashboard/TourClone.vue";
import BlogPost from "@/views/dashboard/BlogPost.vue";
import NewBlogPost from "@/views/dashboard/NewBlogPost.vue";
import EditBlogPost from "@/views/dashboard/EditBlogPost.vue";
import DestinationPost from "@/views/dashboard/DestinationPost.vue";
import NewDestinationPost from "@/views/dashboard/NewDestinationPost.vue";
import EditDestinationPost from "@/views/dashboard/EditDestinationPost.vue";
import LandingPage from "@/views/dashboard/LandingPage.vue";
import NewLandingPage from "@/views/dashboard/NewLandingPage.vue";
import EditLandingPage from "@/views/dashboard/EditLandingPage.vue";
import LandingThings from "@/views/dashboard/LandingThings.vue";
import LandingPlaces from "@/views/dashboard/LandingPlaces.vue";
import NewLandingThings from "@/views/dashboard/NewLandingThings.vue";
import NewLandingPlaces from "@/views/dashboard/NewLandingPlaces.vue";
import EditLandingThings from "@/views/dashboard/EditLandingThings.vue";
import EditLandingPlaces from "@/views/dashboard/EditLandingPlaces.vue";
import TourOperator from "@/views/dashboard/TourOperator.vue";
import OperatorPackage from "@/views/dashboard/OperatorPackage.vue";
import OperatorRearrange from "@/views/dashboard/OperatorRearrange.vue";
import OperatorManagement from "@/views/dashboard/OperatorManagement.vue";
import OperatorWallet from "@/views/dashboard/OperatorWallet.vue";
import OperatorAddFund from "@/views/dashboard/OperatorAddFund.vue";
import UserSetting from "@/views/dashboard/UserSetting.vue";
import UpdatePassword from "@/views/dashboard/UpdatePassword.vue";
import Login from "@/views/Login.vue";
import ForgotPassword from "@/views/ForgotPassword.vue";
import ResetPassword from "@/views/ResetPassword.vue";
import GeneralSetting from "@/views/dashboard/GeneralSetting.vue";
import TourActivity from "@/views/dashboard/TourActivity.vue";
import PageNotFound from "@/views/PageNotFound.vue";
import PhotoManagement from "@/views/dashboard/PhotoManagement.vue";
import Accommodation from "@/views/dashboard/Accommodation.vue";
import NewAccommodation from "@/views/dashboard/NewAccommodation.vue";
import EditAccommodation from "@/views/dashboard/EditAccommodation.vue";
import AddPackageActivity from "@/views/dashboard/AddPackageActivity.vue";
import { Constants } from "../constants.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "login",
    component: Login,
  },
  {
    path: "/forgot-password",
    name: "forgotPassword",
    component: ForgotPassword,
  },
  {
    path: "/reset-password",
    name: "resetPassword",
    component: ResetPassword,
  },
  {
    path: "/dashboard",
    component: Layout,
    children: [
      {
        path: "",
        name: "dashboard",
        component: Dashboard,
        meta: {
          title: "DASHBOARD",
          isProtected: true,
        },
      },
      {
        path: "reviews",
        name: "review",
        component: Review,
        meta: {
          title: "REVIEWS",
          isProtected: true,
        },
      },
      {
        path: "quotes",
        name: "quote",
        component: Quote,
        meta: {
          title: "QUOTE REQUEST",
          isProtected: true,
        },
      },
      {
        path: "tour",
        name: "tourOperator",
        component: TourOperator,
        meta: {
          title: "TOURS",
          isProtected: true,
        },
      },
      {
        path: "operators",
        name: "operatorManagement",
        component: OperatorManagement,
        meta: {
          title: "OPERATORS MANAGEMENT",
          isProtected: true,
        },
      },
      {
        path: "photos",
        name: "photoManagement",
        component: PhotoManagement,
        meta: {
          title: "PHOTO MANAGEMENT",
          isProtected: true,
        },
      },
      {
        path: "packages",
        name: "package",
        component: Package,
        meta: {
          title: "PACKAGES MANAGEMENT",
          isProtected: true,
        },
      },
      {
        path: "package/operator/:id",
        name: "operatorPackage",
        component: OperatorPackage,
        meta: {
          title: "OPERATOR PACKAGES",
          isProtected: true,
        },
      },
      {
        path: "package/rearrange",
        name: "packageRearrange",
        component: OperatorRearrange,
        meta: {
          title: "PACKAGE REARRANGEMENT",
          isProtected: true,
        },
      },
      {
        path: "tour/add",
        name: "tourAdd",
        component: TourAdd,
        meta: {
          title: "ADD TOUR",
          isProtected: true,
        },
      },
      {
        path: "tour/edit/:id",
        name: "tourEdit",
        component: TourEdit,
        meta: {
          title: "Edit TOUR",
          isProtected: true,
        },
      },
      {
        path: "tour/clone/:id",
        name: "tourClone",
        component: TourClone,
        meta: {
          title: "Clone Tour",
          isProtected: true,
        },
      },
      {
        path: "tour/activity/:id",
        name: "addPackageActivity",
        component: AddPackageActivity,
        meta: {
          title: "ADD ACTIVITIES",
          isProtected: true,
        },
      },
      {
        path: "accommodation",
        name: "accommodation",
        component: Accommodation,
        meta: {
          title: "Accommodation",
          isProtected: true,
        },
      },
      {
        path: "accommodation/new",
        name: "newAccommodation",
        component: NewAccommodation,
        meta: {
          title: "NEW ACCOMMODATION",
          isProtected: true,
        },
      },
      {
        path: "accommodation/edit/:id",
        name: "editAccommodation",
        component: EditAccommodation,
        meta: {
          title: "UPDATE ACCOMMODATION",
          isProtected: true,
        },
      },

      {
        path: "blog/post",
        name: "blogPost",
        component: BlogPost,
        meta: {
          title: "BLOG POST",
          isProtected: true,
        },
      },
      {
        path: "blog/new-post",
        name: "newBlogPost",
        component: NewBlogPost,
        meta: {
          title: "NEW BLOG POST",
          isProtected: true,
        },
      },
      {
        path: "blog/post/edit/:id",
        name: "editBlogPost",
        component: EditBlogPost,
        meta: {
          title: "UPDATE BLOG POST",
          isProtected: true,
        },
      },
      {
        path: "destination/post",
        name: "destinationPost",
        component: DestinationPost,
        meta: {
          title: "DESTINATION POST",
          isProtected: true,
        },
      },
      {
        path: "destination/new-post",
        name: "newDestinationPost",
        component: NewDestinationPost,
        meta: {
          title: "NEW DESTINATION POST",
          isProtected: true,
        },
      },
      {
        path: "destination/post/edit/:id",
        name: "editDestinationPost",
        component: EditDestinationPost,
        meta: {
          title: "UPDATE DESTINATION POST",
          isProtected: true,
        },
      },
      {
        path: "landing-page/page",
        name: "landingPage",
        component: LandingPage,
        meta: {
          title: "LANDING PAGE",
          isProtected: true,
        },
      },
      {
        path: "things-to-do/page",
        name: "landingThings",
        component: LandingThings,
        meta: {
          title: "Things to do",
          isProtected: true,
        },
      },
      {
        path: "places-to-visit/page",
        name: "landingPlaces",
        component: LandingPlaces,
        meta: {
          title: "Places to visit",
          isProtected: true,
        },
      },
      {
        path: "landing-page/new-page",
        name: "newLandingPage",
        component: NewLandingPage,
        meta: {
          title: "NEW LANDING PAGE",
          isProtected: true,
        },
      },
      {
        path: "things-to-do/new-page",
        name: "newLandingThings",
        component: NewLandingThings,
        meta: {
          title: "New Things to do",
          isProtected: true,
        },
      },
      {
        path: "places-to-visit/new-page",
        name: "newLandingPlaces",
        component: NewLandingPlaces,
        meta: {
          title: "New Places to visit",
          isProtected: true,
        },
      },
      {
        path: "landing-page/page/edit/:id",
        name: "editLandingPage",
        component: EditLandingPage,
        meta: {
          title: "UPDATE LANDING PAGE",
          isProtected: true,
        },
      },
      {
        path: "things-to-do/page/edit/:id",
        name: "editLandingThings",
        component: EditLandingThings,
        meta: {
          title: "Edit Things to do",
          isProtected: true,
        },
      },
      {
        path: "places-to-visit/page/edit/:id",
        name: "editLandingPlaces",
        component: EditLandingPlaces,
        meta: {
          title: "Edit Places to visit",
          isProtected: true,
        },
      },
      {
        path: "user/setting/:id",
        name: "userSetting",
        component: UserSetting,
        meta: {
          title: "COMPANY INFORMATION",
          isProtected: true,
        },
      },
      {
        path: "user/update/password",
        name: "updatePassword",
        component: UpdatePassword,
        meta: {
          title: "UPDATE PASSWORD",
          isProtected: true,
        },
      },
      {
        path: "user/wallet",
        name: "operatorWallet",
        component: OperatorWallet,
        meta: {
          title: "ACCOUNT WALLET",
          isProtected: true,
        },
      },
      {
        path: "user/wallet/add-fund",
        name: "operatorAddFund",
        component: OperatorAddFund,
        meta: {
          title: "ADD FUND",
          isProtected: true,
        },
      },
      {
        path: "general-setting",
        name: "generalSetting",
        component: GeneralSetting,
        meta: {
          title: "GENERAL SETTINGS",
          isProtected: true,
        },
      },
      {
        path: "tour-activity",
        name: "tourActivity",
        component: TourActivity,
        meta: {
          title: "Manage Activity",
          isProtected: true,
        },
      },
    ],
  },
  { path: "*", component: PageNotFound },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  const user = Cookies.get(Constants.LOGIN_USER);

  // check if user is login
  if (to.name === "login") {
    if (user) {
      next("/dashboard");
    } else {
      next();
    }
  } else if (to.meta.isProtected) {
    if (user) {
      next();
    } else {
      next("/");
    }
  } else {
    next();
  }
});

export default router;
